import { render, staticRenderFns } from "./custom-form-more.vue?vue&type=template&id=6c85bd1d&scoped=true&"
import script from "./custom-form-more.vue?vue&type=script&lang=js&"
export * from "./custom-form-more.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c85bd1d",
  null
  
)

export default component.exports